var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignBottom03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00104 21.0013L6.00246 21.0013M6.00246 21.0013H13.7625M6.00246 21.0013L6.00246 4.61709C6.00246 4.05073 6.00246 3.76752 6.11145 3.5512C6.20732 3.36091 6.3603 3.20621 6.54847 3.10925C6.76238 2.99903 7.0424 2.99902 7.60246 2.99902H8.6451C9.20515 2.99902 9.48517 2.99903 9.69909 3.10925C9.88725 3.20621 10.0402 3.36091 10.1361 3.5512C10.2451 3.76753 10.2451 4.05071 10.2451 4.61709V21.0013M13.7625 21.0013H18.0051M13.7625 21.0013L13.7625 8.46225C13.7625 7.89588 13.7625 7.61269 13.8714 7.39636C13.9673 7.20607 14.1203 7.05137 14.3085 6.95441C14.5224 6.84419 14.8024 6.84419 15.3625 6.84419L16.4051 6.84418C16.9651 6.84418 17.2452 6.84419 17.4591 6.95441C17.6472 7.05137 17.8002 7.20607 17.8961 7.39636C18.0051 7.61269 18.0051 7.89588 18.0051 8.46225V21.0013M18.0051 21.0013H21.001",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignBottom03);
export default __webpack_public_path__ + "static/media/align-bottom-03.fde6b689d0fbfc9ba408204671c88cda.svg";
export { ForwardRef as ReactComponent };